export default __webpack_public_path__ + "static/akearney-43de9561ec5a9a4a871f21f2b0262014.png";